import BaseMystery from '../BaseMystery';

const FirstSorrowfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/c/carpacci/3schiavo/2/agony.jpg",
		"https://www.wga.hu/art/c/callot/agonygar.jpg",
		"https://www.wga.hu/art/b/botticel/91late/12agony.jpg",
		"https://www.wga.hu/art/b/bellini/giovanni/1460-69/060agon.jpg",
		"https://www.wga.hu/art/b/bazzani/agony_g.jpg",
		"https://www.wga.hu/art/c/coecke/agony.jpg",
		"https://www.wga.hu/art/c/cremonin/agony.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/verso_1/verso06.jpg",
		"https://www.wga.hu/art/g/gandolfi/gaetano/agony.jpg",
		"https://www.wga.hu/art/g/gossart/01altar/1altar1.jpg",
		"https://www.wga.hu/art/g/greco_el/08/0815grec.jpg",
		"https://www.wga.hu/art/g/greco_el/15/1501grec.jpg",
		"https://www.wga.hu/art/g/greco_el/15/1502grec.jpg",
		"https://www.wga.hu/art/g/greco_el/17/1704grec.jpg",
		"https://www.wga.hu/art/l/ligozzi/agony.jpg",
		"https://www.wga.hu/art/l/ligozzi/agony1.jpg",
		"https://www.wga.hu/art/m/mantegna/03/7agony.jpg",
		"https://www.wga.hu/art/m/mantegna/04/zeno2p.jpg",
		"https://www.wga.hu/art/s/saraceni/agony.jpg",
		"https://www.wga.hu/art/s/schaufel/agony.jpg",
		"https://www.wga.hu/art/v/velde/adriaen/agony_ga.jpg",
		"https://www.wga.hu/art/a/altdorfe/3/2scenes1.jpg",
	];

	const scriptureQuote = "\"Father, if you are willing, take this cup away from me; still, not my will but yours be done.\"";
	const scriptureCitation = "Luke 22:42 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%2022%3A39-46&version=NABRE";

	return (
		<BaseMystery titleText="The Agony in the Garden"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FirstSorrowfulMystery;